import Bottle from 'bottlejs';
import callbackContainerFactory from './CallbackContainer';
import callbackViewFactory from './CallbackView';

export default () => {
  const CallbackBottle = new Bottle();
  // would be nice if we could easily mock but having issues
  callbackContainerFactory(CallbackBottle);
  callbackViewFactory(CallbackBottle);
  return CallbackBottle;
};
